import script from "./AddRamps.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddRamps.vue?vue&type=script&lang=ts&setup=true"

import "./AddRamps.vue?vue&type=style&index=0&id=1f7421f5&lang=scss&setup=true"

const __exports__ = script;

export default __exports__